import { Android } from '@material-ui/icons';
import React from 'react';

const ChatIcon = ({ color }) => <Android style={{ color }} />;

export default ChatIcon;
